import { render, staticRenderFns } from "./DingYangPage.vue?vue&type=template&id=1b8be1f4&scoped=true&"
import script from "./DingYangPage.vue?vue&type=script&lang=js&"
export * from "./DingYangPage.vue?vue&type=script&lang=js&"
import style0 from "./DingYangPage.vue?vue&type=style&index=0&id=1b8be1f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8be1f4",
  null
  
)

export default component.exports